/**
 * NORTHWEST REGISTERED AGENT — İŞ ORTAKLIĞI BAĞLANTILARI (TEK KAYNAK)
 *
 * Awin üzerinden yürüyen ortaklık: yayıncı WhowSell (2582277), reklamveren
 * Northwest Registered Agent LLC (66946). 19 Ekim 2026'da Awin "website
 * doesn't feature NW" gerekçesiyle üyeliği askıya alma sürecine aldı: ortaklık
 * bir yılı aşkın süredir danışmanlık müşterilerine yapılan yönlendirmelerle
 * yürüyordu ama Awin'e kayıtlı tanıtım alanında (https://www.whowsell.com)
 * Northwest hiç geçmiyordu. Bu dosyadaki bağlantılar o yüzden sitede görünür
 * yerlerde kullanılır (ana sayfadaki bölüm + /us-llc-formation rehberi).
 *
 * Program kuralları (Northwest Terms, 12 Aralık 2025 sürümü) — bu bağlantıları
 * kullanan her yer için geçerli:
 *  - Yalnız Awin'in verdiği takip bağlantıları; değiştirilmez, gizlenmez,
 *    yönlendirme arkasına saklanmaz ("Special Links ... must not be blocked or
 *    hidden by any means").
 *  - Ağ arayüzündeki resmi banner ve metin bağlantıları tercih edilir; banner
 *    görseli Awin'den olduğu gibi gelir, yalnız ölçeklenir (logo kuralları:
 *    gerilmez, rengi değişmez, üstüne bir şey konmaz).
 *  - Bağlantının olduğu yerde affiliate açıklaması (FTC) ve sitede bir yerde
 *    "A Northwest Registered Agent affiliate" ifadesi.
 *  - Rakip (başka kayıtlı temsilci / şirket kuruluş firması) markası ya da
 *    logosu sitede yer almaz; tıklayana ödül / indirim vaat edilmez.
 *
 * rel="sponsored": Awin'in kendi ürettiği kod da böyle (arama motorlarına
 * "ücretli bağlantı" bildirimi). `noreferrer` BİLEREK yok: tıklamanın
 * whowsell.com'dan geldiği Awin raporunda görünsün — denetimin baktığı şey bu.
 */

export const NW_YAYINCI = '2582277';
export const NW_REKLAMVEREN = '66946';

/**
 * LLC kuruluş sayfası — Selçuk'un Awin Link Builder'da ürettiği kısa bağlantı
 * (tidd.ly Awin'in kendi kısaltıcısı). 20 Ekim 2026'da doğrulandı:
 * northwestregisteredagent.com/llc adresine `sv_campaign_id=2582277` ve
 * 66946 önekli `awc` ile varıyor. Gruplarda paylaşılan bağlantıyla aynı.
 */
export const NW_LLC_BAGLANTISI = 'https://tidd.ly/4byKbfc';

/**
 * Yalnız kayıtlı temsilci (registered agent) hizmeti — Awin "My Creative"
 * resmi metin bağlantısı #4428868 ("Standalone Registered Agent landing page"),
 * kodu olduğu gibi. Zaten şirketi olup yalnız temsilci arayanlar için.
 */
export const NW_TEMSILCI_BAGLANTISI =
  'https://www.awin1.com/awclick.php?gid=573874&mid=66946&awinaffid=2582277&linkid=4428868&clickref=';

/** Awin resmi görsel banner: tıklama `cread.php`, görsel `cshow.php` — aynı parametreler. */
function awinBanner(s, q, genislik, yukseklik) {
  const parametre = `s=${s}&v=${NW_REKLAMVEREN}&q=${q}&r=${NW_YAYINCI}`;
  return {
    href: `https://www.awin1.com/cread.php?${parametre}`,
    src: `https://www.awin1.com/cshow.php?${parametre}`,
    genislik,
    yukseklik,
  };
}

/**
 * Resmi logo bannerları (#4844806 birincil, #4844807 beyaz yazılı).
 * Koyu temada beyaz yazılı, açık temada birincil (mavi) sürüm: logo kuralı
 * "dikkat dağıtan zeminde kullanma" diyor; her temada okunur olanı gösterilir.
 * Yalnız biri çizilir — ikisini birden koyup CSS ile gizlemek iki gösterim
 * sayardı (gizli görsel de çoğu tarayıcıda yüklenir).
 */
export const NW_LOGO = {
  koyu: awinBanner(4844807, 604575, 1698, 224),
  acik: awinBanner(4844806, 604575, 1698, 224),
};

/**
 * Rehber sayfasının banner'ı: #4428985 "LLC Landing Page" 300x250. Tek boyut
 * bilerek: 300px her ekrana sığar (en dar ekranda orantılı küçülür), geniş /
 * dar için iki ayrı banner koymak yine çift gösterim demekti.
 */
export const NW_REHBER_BANNER = awinBanner(4428985, 573881, 300, 250);
